module.exports = __webpack_public_path__ + "img/1970East-027_WEB-min.2ee25730.jpg";